/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const productDetailsBinaryElementSX: SxProps<Theme> = {
	width: { xs: '100%', md: '42%' },
};

export const productDetailsImageBinaryElementSX: SxProps<Theme> = {
	width: { xs: '100%', md: '60%' },
	'@media (max-width: 1405px)': {
		width: '70%',
	},

	'@media (max-width: 1310px)': {
		width: '76%',
	},

	'@media (max-width: 1279px)': {
		width: '60%',
	},

	'@media (max-width: 1140px)': {
		width: '65%',
	},

	'@media (max-width: 960px)': {
		width: '100%',
	},
};

export const productDetailsImageBinaryElementMobileSX: SxProps<Theme> = {
	width: { xs: '100%', md: '58%' },
	marginBottom: '12px',
};

export const productDetailsImageBinaryElementMobile2SX: SxProps<Theme> = {
	width: { xs: '100%', md: '58%' },
	marginBottom: '12px',
	marginTop: '10px',
};

export const productDetailsPromosElementMobile2SX: SxProps<Theme> = {
	width: { xs: '100%', md: '58%' },
};
